const urlSearchParams = new URLSearchParams(window.location.search);
const isIframed = urlSearchParams.has('framed');

export default function isInIframe()
{
    return isIframed;
}
